import { render, staticRenderFns } from "./FormFixedAsset.vue?vue&type=template&id=6e84dfc3"
import script from "./FormFixedAsset.vue?vue&type=script&lang=js"
export * from "./FormFixedAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports